/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */

export type BulkReprocessRunItemDtoStatus = typeof BulkReprocessRunItemDtoStatus[keyof typeof BulkReprocessRunItemDtoStatus];


export const BulkReprocessRunItemDtoStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
} as const;
